import type { ReactNode } from 'react'
import { useMemo } from 'react'

import { ErrorBoundary } from 'react-error-boundary'
import { styled } from 'styled-components'

import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { useLogError } from '@/helpers/useLogError'

const FallbackWrapper = styled.div`
  margin-bottom: 1rem;
`

const Fallback = () => (
  <FallbackWrapper role="alert">
    <Banner type="warning">
      <FormattedMessage id="Listing.actionColumn.payment.errorBoundary.message" />
    </Banner>
  </FallbackWrapper>
)

export const PaymentErrorBoundary = ({
  listingId,
  children,
}: {
  listingId: string
  children: ReactNode
}) => {
  const logErrorContext = useMemo(
    () => ({ listingId, boundary: 'Payment' as const }),
    [listingId]
  )
  const logError = useLogError(logErrorContext)

  return (
    <ErrorBoundary FallbackComponent={Fallback} onError={logError}>
      {children}
    </ErrorBoundary>
  )
}
